import { CookiesStorageService } from "@Engage.Data/services";
import { CookiesKeys } from "@Engage.Data/constants/Constants";
export class ActionRepository {
    static setPossibilityPresentForUser(checked) {
        CookiesStorageService.set(CookiesKeys.RegistrationWalls, JSON.stringify(checked), { expires: 1 });
    }
    static deletePossibilityPresentForUser() {
        CookiesStorageService.delete(CookiesKeys.RegistrationWalls);
    }
}
